module.exports = {
	"levels": [
		{
			"name": "May The Force Be With You",
			"created": "2021-04-22",
			"difficulty": "3",
			"description": "maytheforcebewithyou.md",
			"completedDescription": "maytheforcebewithyou_complete.md",
			"levelContract": "MayTheForceBeWithYouFactory.sol",
			"instanceContract": "MayTheForceBeWithYou.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 0,
			"deployId": "1",
			"instanceGas": 8000000,
			"author": "raz0r"
		},
		{
			"name": "DiscoLP",
			"created": "2021-04-30",
			"difficulty": "7",
			"description": "discolp.md",
			"completedDescription": "discolp_complete.md",
			"levelContract": "DiscoLPFactory.sol",
			"instanceContract": "DiscoLP.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 0,
			"deployId": "2",
			"instanceGas": 8000000,
			"author": "raz0r"
		},
		{
			"name": "P2PSwapper",
			"created": "2021-05-11",
			"difficulty": "5",
			"description": "p2pswapper.md",
			"completedDescription": "p2pswapper_complete.md",
			"levelContract": "P2PSwapperFactory.sol",
			"instanceContract": "P2PSwapper.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 1,
			"deployId": "3",
			"instanceGas": 8000000,
			"author": "beched"
		},
		{
			"name": "FakerDAO",
			"created": "2021-05-13",
			"difficulty": "7",
			"description": "fakerdao.md",
			"completedDescription": "fakerdao_complete.md",
			"levelContract": "FakerDAOFactory.sol",
			"instanceContract": "FakerDAO.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 0,
			"deployId": "4",
			"instanceGas": 8000000,
			"author": "raz0r"
		},
		{
			"name": "Main Khinkal Chef",
			"created": "2021-05-16",
			"difficulty": "5",
			"description": "mainchef.md",
			"completedDescription": "mainchef_complete.md",
			"levelContract": "MainChefFactory.sol",
			"instanceContract": "MainChef.sol",
			"revealCode": true,
			"deployParams": [],
			"deployFunds": 0,
			"deployId": "5",
			"instanceGas": 8000000,
			"author": "beched"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./gamedata/gamedata.json
// module id = 1519
// module chunks = 0